/* eslint-disable no-param-reassign */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AnalaysisSelect from "../ReportTypes/AnalaysisSelect/AnalaysisSelect";
import { Tabs, Button } from "antd";
import { useDispatch } from "react-redux";
import useLanguages from "../../../hooks/useLanguages"
import useShowInsights from "../../../hooks/useShowInsights";
import CategoryDeepDive from "../ReportTypes/CategoryDeepDive/CategoryDeepDive";
import GeneralMarketCategories from "../ReportTypes/GeneralMarketCategories/GeneralMarketCategories";
import AudienceSpecificCategories from "../ReportTypes/AudienceSpecificCategories/AudienceSpecificCategories"
import GenerateGrid from "../ReportTypes/GenerateGrid/GenerateGrid"
import CompareDetails from "../Insights/CompareDetails"
import CrownSubscription from "../Insights/CrownSubscription";
import { setCompareResultTab } from "../../../store/components/Insights.slice";
import CountryLanguages from "../../General/CountryLanguages";
import WhiteSpaceNewDisplay from "../../ReportBuilder/ReportTypes/WhiteSpaceCharts/WhiteSpaceNewDisplay"
import { PlusSquareOutlined } from "@ant-design/icons";
import ScrapedKeywords from "../ScrapedKeywords/ScrapedKeywords";
import { useEffect } from "react";
import { isHasScrapeTopicBrandPermission, isViewer } from "../../../utils/MainHelper";
import { setScrapeViewer } from "../../../store/components/BuildTargets.slice";
import { isDev } from "../../../utils/MainHelper";
import Container from "../../General/Container/Container";
import { getMarketPackageCode } from "../../../utils/oneintelligence/OneIntelligenceHelper";


const { TabPane } = Tabs;
function ReportBuilderResultContent({
    setBehaviouralSegmentData,
    setShowWhitespacesSelection,
    setShowAddBehaviouralSegment,
    setShowFreeForm,
    setshowQuickReport
}) {
    const dispatch = useDispatch();
    const {
        generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData, reportIsLoading
    } = useSelector((state) => state.reports);

    const { mode } = useSelector((state) => state.reportBuilder);

    const { compareResultTab, compare1, compare2 } = useSelector((state) => state.insights);

    const {
        scrapeViewer
    } = useSelector((state) => state.buildTargets);

    const {
        value,
        setLanguage,
        list
    } = useLanguages()
    const marketPackageCode = getMarketPackageCode();
    const { showInsights } = useShowInsights()

    const getContent = () => {

        if (["fullmarket", "singlecategory", "marketcategory", "hcpattributes", "hcpmarketscan", "petientmarketscan", "freeform",
            "yahoo_audiences_attribute_targeting",
            "yahoo_audiences_interests",
            "yahoo_audiences_purchase_intent_targeting",
            "analysis_gdn&trv_affinity",
            "analysis_gdn&trv_purchase",
            "analysis_gdn&trv_topic",
            "tiktokhastags",
            "tiktokinterest",
            "tiktokvideointeractions",
            "purchaseintentions",
            "icd10clinicalmodification",
            "icd10procedurecodingsystem",
            "tiktokcreatorinteractions",
            "la_demographicsattributes",
            "la_behavioralattributes",
            "la_purchaseintent",
            "la_hobbiesinterests",
            "medicaljournal",
            "medicalassociations",
            "medicalwebsites",
            "medicalconferences",
            "continuingmedicaleducation"
        ].includes(mode) || (marketPackageCode !== "whitespaces" && "mokb_analysis" === mode)) {
            const categoryElement = (
                <CategoryDeepDive
                    data={categoryDeepDiveData}
                    loading={reportIsLoading}
                    setBehaviouralSegmentData={setBehaviouralSegmentData}
                    setShowAddBehaviouralSegment={setShowAddBehaviouralSegment}
                />
            );
            if (mode === "fullmarket") {
                return (
                    <>
                        <GeneralMarketCategories data={generalMarketCategoriesData} loading={reportIsLoading} />
                        <AudienceSpecificCategories data={audienceSpecificCategoriesData} loading={reportIsLoading} />
                        {categoryDeepDiveData.length
                            ? categoryElement
                            : null}
                    </>
                );
            }
            return categoryElement;
        }
        if (["candidatewhitespaces",
            "analysis_politicaltaxonomy",
            "usersearchjourney",
            "otherwhitespaces",
            "claimswhitespaces",
            "ingredientshitespaces",
            "safetycocernsideeffectswhitespaces",
            "macrowhitespaces",
            "standardtreatmentjourney",
            "othermacrowhitespaces",
            "symptomswhitespaces",
            "mokb_analysis",
            "diagnosistreatmentwhitespaces"].includes(mode)) {
            if (isDev()) return <GenerateGrid />;
            return <WhiteSpaceNewDisplay />;
        }
        if (mode === "select") {
            return {
                element: (
                    <AnalaysisSelect
                        showQuickReport={setshowQuickReport}
                        showFreeForm={setShowFreeForm}
                        showBehavioralSegment={setShowAddBehaviouralSegment}
                        showWhitespacesSelection={setShowWhitespacesSelection}
                    />
                )
            };
        }
        return "";
    };

    const component = getContent();

    const operations = (
        <>
            {
                isHasScrapeTopicBrandPermission() ? <Button
                    icon={<PlusSquareOutlined />}
                    type="link"
                    onClick={() => {
                        // dispatch(setScrapeViewer(true))
                        window.open("https://oneknowledge.sqreemtech.com/")
                    }}
                    disabled={reportIsLoading}
                >
                    Add New to My Own Knowledge Base
                </Button> : null
            }

            {
                compareResultTab === "compareresult" ? (
                    <CountryLanguages
                        list={list}
                        selectProps={{
                            style: { marginRight: "10mm", width: 150 },
                            value,
                            onChange: (e) => {
                                setLanguage(e);
                            }
                        }}
                    />
                ) : null
            }
        </>
    )

    const renderComponent = () => {
        const appendToParent = (child) => {
            return <Container className="fullscreen" style={{ overflowY: "auto", overflowX: "hidden", paddingRight: "2mm" }}>
                {child}
            </Container>
        }
        if (isViewer()) {
            if (component.element) return appendToParent(component.element);
            return appendToParent(component);
        }
        if (component.element) return appendToParent(component.element);
        if (!showInsights) return appendToParent(component);
        return <Tabs
            className="report--result--tabs"
            activeKey={compareResultTab}
            onChange={(e) => {
                dispatch(setCompareResultTab(e));
            }}
            tabBarExtraContent={{ right: operations }}
        >
            <TabPane
                tab="Deepdive"
                key="deepdive"
            >
                {appendToParent(component)}
            </TabPane>
            <TabPane
                disabled={!(compare1 && compare2)}
                tab={(
                    <div className="d-flex gap-5p align-items-center">
                        <span>Compare Results</span>
                        <CrownSubscription />
                    </div>
                )}
                key="compareresult"
            >
                <CompareDetails language={value} />
            </TabPane>
        </Tabs>
    }

    useEffect(() => {
        if (reportIsLoading) dispatch(setScrapeViewer(false))
    }, [reportIsLoading])

    return (
        <>
            {
                scrapeViewer ? <ScrapedKeywords /> : renderComponent()
            }
        </>
    );
}
export default ReportBuilderResultContent;
